var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('b-card',{staticClass:"shadow-none bg-transparent",attrs:{"no-body":""}},[_c('date-picker')],1),(_vm.loading)?_c('card-loader',{staticClass:"mt-3",attrs:{"height":"150px"}}):_vm._e(),(_vm.records.length)?_c('score-participation-evolution-chart',{staticClass:"mt-3",attrs:{"dates":_vm.dates,"participation":_vm.participation,"title":_vm.title}}):_vm._e(),_c('list',{staticClass:"mt-3",attrs:{"columns":_vm.columns,"rows":_vm.records,"select-options":{
            enabled: false,
        },"pagination-options":{
            perPage: 20,
        },"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }